// removed by extract-text-webpack-plugin
module.exports = {"card":"_3Tx-tmegnj5WOmTlUpjP7_","left":"_1yeo21gAio3zo1SxyEPesc","body":"_2d5_uweuxHsxCeRvPaieP","mainText":"_1kl5ac23fWdiY8kDoyLiLm","subText":"_3VKStwiV_J9VoyzHG3Pi4L","statusBox":"_2szNCuLaZeYsRfGEKOsFlB","wait":"ER1AmQXYUgt-KiTAz9pa2","accept":"_1dUJn6zSqd5Y2iaIaZKA6P","cancel":"_1lw3lY09AyMhMbUwTo0tHs","right":"_3HER3Qg5Zf1X6zlbM-cBn5","more":"_3ZdnlTpbIZUh9JJA-wj-tm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/CardBookingRequest.scss
// module id = 447
// module chunks = 0